import React from 'react';
import { getShopLabelByCategoryId } from '@sbt-web/utils';
import { Badge } from '@sbt-web/ui';
import { PhoneContact } from './PhoneContact/index.js';
import { ShopLink } from './ShopLink/index.js';
import classes from './index.module.scss.js';

const ProSection = ({ apiBase, impresapiuBase, ad, search, pulseInstance, pageTypeForTracking, houstonTrackConversion, hideProDetails, }) => {
    const label = getShopLabelByCategoryId(ad.category.id);
    return (React.createElement("div", { className: classes.container },
        !hideProDetails && (React.createElement("div", { className: classes.badgeAndShop },
            label && React.createElement(Badge, null, label),
            React.createElement(ShopLink, { impresapiuBase: impresapiuBase, ad: ad, pulseInstance: pulseInstance }))),
        !!ad.advertiser.phone && (React.createElement("div", { className: classes.phoneContainer },
            React.createElement(PhoneContact, { apiBase: apiBase, ad: ad, search: search, pulseInstance: pulseInstance, pageTypeForTracking: pageTypeForTracking, houstonTrackConversion: houstonTrackConversion })))));
};

export { ProSection };
//# sourceMappingURL=index.js.map
